import { render, staticRenderFns } from "./FclList.vue?vue&type=template&id=5a0174fe&scoped=true"
import script from "./FclList.vue?vue&type=script&lang=js"
export * from "./FclList.vue?vue&type=script&lang=js"
import style0 from "./FclList.vue?vue&type=style&index=0&id=5a0174fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0174fe",
  null
  
)

export default component.exports